
export default class HeaderMenu {
    static init(){
        const headerMobileMenu = document.getElementById('header-mobile-menu')
        const headerMobileMenuToggle = document.getElementById('header-mobile-menu-toggle')
        headerMobileMenu.addEventListener('hide.bs.collapse', function () {
            headerMobileMenuToggle.classList.toggle('open')
        })
        headerMobileMenu.addEventListener('show.bs.collapse', function () {
            headerMobileMenuToggle.classList.toggle('open')
        })
    }
}